// extracted by mini-css-extract-plugin
export default {"header":"tdN4r","statistics":"Fp7Us"};